import styled from 'styled-components';
import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';

export const DividerLine = styled.div`
  margin: ${({ theme }) => theme.spacing.values.plusHalf} 0;
  border-bottom: ${({ theme }) => `
    ${theme.spacing.values.single} solid #bdbdbd;
  `};
`;

export const DATA_TEST = {
  divider: 'divider',
};

export const Divider = () => {
  const { isEnabled } = useCatalogSelectionContext();
  return isEnabled ? <DividerLine data-test={DATA_TEST.divider} /> : null;
};
